export {
  PreSubmitSignature,
  preSubmitSignatureConfig,
  normalizeName,
  getValidSignerNames,
  isSignatureValid,
} from './pre-submit-signature';
